import { Component, createElement } from "rax";
import classnames from "classnames";
interface Props {
  selected: boolean;
  title: string;
  imageUrl?: string;
  onClick: () => void;
}
export default class TabItem extends Component<Props> {
  render() {
    const {
      title,
      selected,
      imageUrl
    } = this.props;
    return <div className={classnames("header-hor-tab-item", {
      "header-hor-tab-item-select": selected
    })} onclick={this.props.onClick}>
        <div className="header-hor-tab-item-content">
          {imageUrl && <img src={imageUrl} />}
          {title}
        </div>
        {selected && <div className="header-hor-tab-indicator" />}
      </div>;
  }

}